import { ReactElement, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { HiOutlineArrowLeft } from 'react-icons/hi2';
import Spinner from './Spinner';

interface SectionHeaderProps {
  title: string;
  isLoading?: boolean;
  backLink?: {
    to: string;
    text: string;
  };
  actions?: ReactNode;
  className?: string;
  titleClassName?: string;
  inset?: boolean;
}

export default function SectionHeader({
  title,
  isLoading = false,
  backLink,
  actions,
  className = '',
  titleClassName = '',
  inset = false,
}: SectionHeaderProps): ReactElement {
  const baseClasses = 'cr-mb-8 cr-mt-6 cr-w-full';
  const insetClasses = inset ? 'cr-rounded-lg cr-bg-white cr-px-6 cr-py-4' : '';
  const insetStyle = inset
    ? { boxShadow: 'inset 0 2px 6px rgba(0, 0, 0, 0.12), inset 0 1px 3px rgba(0, 0, 0, 0.08)' }
    : {};

  return (
    <div
      className={`${baseClasses} ${insetClasses} ${className}`}
      style={insetStyle}
    >
      <div className="cr-flex cr-items-center cr-justify-between cr-gap-8">
        <h1 className={`font-montserrat cr-flex cr-flex-row cr-text-xl cr-uppercase cr-text-[#03365D] ${titleClassName}`}>
          {title}
          <span className="cr-ml-2">
            <Spinner isFetching={isLoading} />
          </span>
        </h1>
        <div className="mx-6 cr-flex-1 cr-border-b cr-border-gray-300"></div>
        <div className="cr-flex cr-items-center cr-gap-2">
          {actions}
          {backLink && (
            <Link
              to={backLink.to}
              className="cr-flex cr-items-center cr-gap-x-1.5 cr-whitespace-nowrap cr-rounded-md cr-bg-gray-200 cr-px-3 cr-py-1.5 cr-text-sm cr-font-semibold cr-text-[#03365D] cr-no-underline cr-transition-colors cr-duration-200 hover:cr-bg-cirrusBlue-50"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              <HiOutlineArrowLeft className="cr-h-4 cr-w-4" />
              {backLink.text}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
